var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-card-title',{staticStyle:{"margin-bottom":"0px"}},[_c('b-row',[_c('b-col',[_vm._v(" Today's Menu")])],1)],1),_c('VMealItem',{key:JSON.stringify(_vm.getMenuToday),attrs:{"menu":_vm.getMenuToday}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }